import { Label } from '@lognai/synapse-design-system-v2';
import { cn } from '@lognai/synapse-design-system-v2';
import {
  useDensity,
  DENSITY_LABELS,
  DENSITY_HINTS,
  type Density,
} from '../hooks/useDensity';

const OPTIONS: Density[] = ['comfortable', 'default', 'compact'];

/**
 * Row-density control for Settings → Appearance.
 *
 * Applies instantly: the hook sets `data-density` on <html> and the design
 * system's `--space-*` custom properties do the rest, so there is no save step
 * and nothing re-renders.
 */
export function DensityPicker() {
  const { density, setDensity } = useDensity();

  return (
    <div>
      <Label id="density-label">Row density</Label>
      <p className="mt-0.5 text-xs text-muted-foreground">
        How much space sits around table rows, cards and page content.
      </p>
      <div role="radiogroup" aria-labelledby="density-label" className="mt-2 flex flex-wrap gap-2">
        {OPTIONS.map((option) => {
          const selected = density === option;
          return (
            <button
              key={option}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => setDensity(option)}
              title={DENSITY_HINTS[option]}
              className={cn(
                'rounded-md border px-3 py-1.5 text-sm transition-colors',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                selected
                  ? 'border-primary bg-primary-subtle font-medium text-primary'
                  : 'border-border text-muted-foreground hover:bg-muted hover:text-foreground'
              )}
            >
              {DENSITY_LABELS[option]}
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-muted-foreground">{DENSITY_HINTS[density]}</p>
    </div>
  );
}
